/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getFlow} from '../api'

 export const useQueryGetFlow = createReactQueryHook('getFlow', getFlow)
